import { render, staticRenderFns } from "./DashboardConsentDetail.vue?vue&type=template&id=9301c976&scoped=true&"
import script from "./DashboardConsentDetail.vue?vue&type=script&lang=js&"
export * from "./DashboardConsentDetail.vue?vue&type=script&lang=js&"
import style1 from "./DashboardConsentDetail.vue?vue&type=style&index=1&id=9301c976&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9301c976",
  null
  
)

export default component.exports